/* NAKED US : comportements maison posés sur Horizon. */
(function () {
  'use strict';
  // Menu mobile : le bouton menu d'Horizon ouvre le méga-menu NAKED (DA d'origine) sous 990 px.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('summary.header__icon--menu');
    if (!t || window.innerWidth >= 990 || !window.MobileMegaMenu) return;
    e.preventDefault(); e.stopImmediatePropagation();
    window.MobileMegaMenu.open();
  }, true);
})();

/* Cartes produit Horizon : au survol, la 2e photo apparaît en fondu PAR-DESSUS la 1re, seulement une fois chargée
   (comme la vitrine FR). Le diaporama d'Horizon ne défile plus au survol : plus d'écran blanc. Sans 2e photo : rien. */
(function () {
  'use strict';
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
  function secondSrc(g) {
    var slides = g.querySelectorAll('slideshow-slide');
    var img = slides[1] && slides[1].querySelector('img');
    if (!img) return null;
    if (img.currentSrc) return img.currentSrc;
    var ss = img.getAttribute('srcset');
    if (ss) {
      var c = ss.split(',').map(function (x) { var p = x.trim().split(/\s+/); return { u: p[0], w: parseInt(p[1], 10) || 0 }; })
        .sort(function (a, b) { return a.w - b.w; });
      var pick = c.find(function (x) { return x.w >= 600; }) || c[c.length - 1];
      return pick && pick.u;
    }
    return img.getAttribute('src');
  }
  function prep(g) {
    if (g.__nkHov !== undefined) return g.__nkHov;
    var src = secondSrc(g); g.__nkHov = null;
    if (!src) return null;
    var o = document.createElement('img');
    o.className = 'nk-hov-img'; o.alt = ''; o.decoding = 'async'; o.setAttribute('aria-hidden', 'true');
    o.onload = function () { o.dataset.ready = '1'; if (g.matches(':hover')) g.classList.add('nk-hov-on'); };
    o.src = src;
    g.appendChild(o); g.__nkHov = o;
    return o;
  }
  document.addEventListener('pointerenter', function (e) {
    var g = e.target;
    if (!(g instanceof Element) || !g.matches('.card-gallery')) return;
    e.stopImmediatePropagation();
    var o = prep(g);
    if (o && o.dataset.ready) g.classList.add('nk-hov-on');
  }, true);
  document.addEventListener('pointerleave', function (e) {
    var g = e.target;
    if (!(g instanceof Element) || !g.matches('.card-gallery')) return;
    e.stopImmediatePropagation();
    g.classList.remove('nk-hov-on');
  }, true);
})();

/* Pastille panier de l'en-tête : même nombre que le panier maison (pièces achetées, sans cadeaux ni protection colis). */
(function () {
  'use strict';
  function sync() {
    var c = document.querySelector('naked-cart .nkc-head__count');
    var b = document.querySelector('.cart-bubble__text-count');
    if (!c || !b) return;
    var n = (c.textContent.match(/\d+/) || [])[0];
    if (n != null && b.textContent.trim() !== n) b.textContent = n;
  }
  var mo = new MutationObserver(function () { sync(); });
  function start() {
    var nc = document.querySelector('naked-cart');
    if (nc) mo.observe(nc, { childList: true, subtree: true, characterData: true });
    var hb = document.querySelector('.cart-bubble'); if (hb) mo.observe(hb, { childList: true, subtree: true, characterData: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Rails de produits (.nk-rail) et rangées d'images (.nk-il) : barre de progression + flèches rondes, comme la vitrine FR. */
(function () {
  'use strict';
  var ARW = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M7.5 2 3.5 6l4 4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
  function step(el) { var first = el.querySelector('.nk-card, .nk-il__item'); var w = first ? first.getBoundingClientRect().width + 6 : el.clientWidth * 0.8; return Math.max(w, el.clientWidth - w); }
  function rail(el) {
    if (el.dataset.nkCtrl) return; el.dataset.nkCtrl = '1';
    var ctrl = document.createElement('div'); ctrl.className = 'nk-rail-ctrl';
    ctrl.innerHTML = '<div class="nk-rail-track"><span class="nk-rail-thumb"></span></div>' +
      '<button type="button" class="nk-rail-btn nk-rail-btn--prev" aria-label="Previous">' + ARW + '</button>' +
      '<button type="button" class="nk-rail-btn nk-rail-btn--next" aria-label="Next">' + ARW + '</button>';
    el.insertAdjacentElement('afterend', ctrl);
    var thumb = ctrl.querySelector('.nk-rail-thumb'), prev = ctrl.querySelector('.nk-rail-btn--prev'), next = ctrl.querySelector('.nk-rail-btn--next');
    function upd() {
      var max = el.scrollWidth - el.clientWidth, r = el.scrollWidth ? el.clientWidth / el.scrollWidth : 1;
      thumb.style.width = (Math.min(1, r) * 100) + '%';
      thumb.style.transform = 'translateX(' + (max > 0 ? (el.scrollLeft / max) * ((1 / Math.min(1, r)) - 1) * 100 : 0) + '%)';
      prev.disabled = el.scrollLeft <= 2; next.disabled = el.scrollLeft >= max - 2;
      ctrl.hidden = max <= 2;
    }
    prev.addEventListener('click', function () { el.scrollBy({ left: -step(el), behavior: 'smooth' }); });
    next.addEventListener('click', function () { el.scrollBy({ left: step(el), behavior: 'smooth' }); });
    el.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    new ResizeObserver(upd).observe(el);
  }
  function il(row) {
    if (row.dataset.nkCtrl) return; row.dataset.nkCtrl = '1';
    var wrap = row.parentElement, prev = wrap.querySelector('[data-nk-il-prev]'), next = wrap.querySelector('[data-nk-il-next]');
    function upd() { var max = row.scrollWidth - row.clientWidth; if (prev) prev.disabled = row.scrollLeft <= 2; if (next) next.disabled = row.scrollLeft >= max - 2; wrap.classList.toggle('nk-il__wrap--static', max <= 2); }
    if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(row), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(row), behavior: 'smooth' }); });
    row.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }
  function scan() { document.querySelectorAll('.nk-rail').forEach(rail); document.querySelectorAll('[data-nk-il-row]').forEach(il); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('nk:rail-loaded', scan);
  var pend = 0; new MutationObserver(function () { if (pend) return; pend = requestAnimationFrame(function () { pend = 0; scan(); }); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

/* Recherche (bureau) : filtres de la colonne fermés au chargement, comme la vitrine FR. */
(function () {
  if (!document.body.classList.contains('nk-tpl-search') || window.innerWidth < 750) return;
  function closeAll() { document.querySelectorAll('.facets--vertical details[open]').forEach(function (d) { d.removeAttribute('open'); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', closeAll); else closeAll();
})();

/* Aperçu Shopify seulement : la barre d'aperçu (#PBarNextFrameWrapper, fixée en bas) recouvrait la barre d'achat et la vidéo
   « try-on ». On mesure sa hauteur réelle et on remonte les deux d'autant (--nk-pbar). Sans barre d'aperçu : 0 px, rien ne change. */
(function () {
  'use strict';
  var root = document.documentElement, ro = null, seen = null;
  function upd() {
    var w = document.getElementById('PBarNextFrameWrapper'), h = 0;
    if (w) {
      var cs = getComputedStyle(w), r = w.getBoundingClientRect();
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.top < window.innerHeight) h = Math.max(0, Math.round(window.innerHeight - r.top));
      if (w !== seen && window.ResizeObserver) { if (ro) ro.disconnect(); ro = new ResizeObserver(upd); ro.observe(w); seen = w;
        new MutationObserver(upd).observe(w, { attributes: true, attributeFilter: ['style', 'class', 'hidden'], subtree: true }); }
    }
    root.style.setProperty('--nk-pbar', h + 'px');
  }
  upd();
  window.addEventListener('resize', upd);
  new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length || m[i].removedNodes.length) { upd(); break; } }).observe(document.body || root, { childList: true });
  var n = 0, t = setInterval(function () { upd(); if (++n > 20 && !document.getElementById('PBarNextFrameWrapper')) clearInterval(t); }, 1000);
})();
